import type { ReactNode } from 'react';

export function PmoCard({ children, className = '' }: { children: ReactNode; className?: string }) {
  return (
    <section className={`rounded-[14px] border border-[#e8edf1] bg-white shadow-[0_1px_2px_rgba(15,23,42,0.04)] ${className}`}>
      {children}
    </section>
  );
}

export function PmoCardHeader({ title, action }: { title: string; action?: ReactNode }) {
  return (
    <div className="flex items-center justify-between gap-3 border-b border-[#f1f5f9] px-4 py-3">
      <h4 className="text-[13.5px] font-bold text-slate-900">{title}</h4>
      {action}
    </div>
  );
}
